import Styleguide from "@store/Framework/Types/Styleguide";

const content: Styleguide["content"] = {
    isFullWidth: true,
};

export default content;
